var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 0H6C2.68629 0 0 2.68629 0 6V46C0 49.3137 2.68629 52 6 52H46C49.3137 52 52 49.3137 52 46V6C52 2.68629 49.3137 0 46 0Z",
    fill: "#FFD1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.915 24.0493L28.604 25.1729H22.6626L22.9736 24.0493H28.915ZM26.0396 31L22.8467 27.2358L22.8403 26.29H24.3574C24.751 26.29 25.0747 26.2202 25.3286 26.0806C25.5868 25.9367 25.7793 25.7441 25.9062 25.5029C26.0332 25.2575 26.0967 24.9845 26.0967 24.6841C26.0967 24.3582 26.0374 24.0705 25.9189 23.8208C25.8005 23.5711 25.6121 23.3765 25.354 23.2368C25.0959 23.0972 24.7552 23.0273 24.332 23.0273H22.6689L23.0117 21.7578H24.332C25.0811 21.7578 25.7031 21.87 26.1982 22.0942C26.6934 22.3185 27.0636 22.6444 27.3091 23.0718C27.5588 23.4992 27.6836 24.0155 27.6836 24.6206C27.6836 25.1496 27.5926 25.6172 27.4106 26.0234C27.2287 26.4255 26.9346 26.7513 26.5283 27.001C26.1221 27.2464 25.5825 27.3988 24.9097 27.458L27.8296 30.9175V31H26.0396ZM28.9214 21.7578L28.604 22.8813H23.748L24.0591 21.7578H28.9214Z",
    fill: "#E83E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 26C36.4167 31.75 31.75 36.4167 26 36.4167C20.25 36.4167 15.5833 31.75 15.5833 26C15.5833 20.25 20.25 15.5833 26 15.5833",
    stroke: "#E83E8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 19.75V15.5833H32.25",
    stroke: "#E83E8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2083 20.7917L36.4167 15.5833",
    stroke: "#E83E8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualWithdrawal);
export default __webpack_public_path__ + "static/media/manual-withdrawal.3068049e762e550c38aeedaf240e4bfe.svg";
export { ForwardRef as ReactComponent };